import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { BlushIconPNG } from 'utils/assets/branding';
import { SEOIndex } from 'utils/assets/seo';

const MktHead = (props) => {
	const { title, description, img, url } = props;
	const { pathname } = useLocation();


  // Render
	return (
    <Helmet>
      <link rel="shortcut icon" href={BlushIconPNG} />
      <title>{title}</title>
      <meta name="description" content={description} />
      {(typeof window !== 'undefined' && window.env.REACT_APP_NODE_ENV !== 'production') && <meta name="robots" content="noindex" />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={SEOIndex} />
      <meta property="og:url" content={pathname} />

      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={SEOIndex} />
      <meta property="twitter:card" content='summary_large_image' />
      <script async src="https://www.googletagmanager.com/gtag/js?id=AW-371597806"></script> 
      <script>{`window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'AW-371597806');`}</script>
      <script>{
        `(function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "rrupbj2ez7");`}</script>
    </Helmet>
	)
}


MktHead.defaultProps = {
	title: 'Blush | On-Demand Beauty',
	description: 'Book a beauty pro to come to your location for any event.',
}


export default MktHead;
